// If you are adding a term to the ActionSubject glossary,
// please add a member of the Data team to your PR

// To use with sendUpdatedBoardFieldEvent
// See server/app/schema/board.js for parity
const boardFields = {
  background: 'background',
  name: 'name',
  star: 'star',
  visibility: 'visibility', // Permission level
  votingPref: 'votingPref',
  hideVotesPref: 'hideVotesPref',
  commentsPref: 'commentsPref',
  invitationsPref: 'invitationsPref',
  selfJoinPref: 'selfJoinPref',
  cardCoversPref: 'cardCoversPref',
  cardAgingPref: 'cardAgingPref',
  calendarFeedEnabledPref: 'calendarFeedEnabledPref',
  isTemplate: 'isTemplate', // No "Pref"
} as const;

const otherActionSubjects = {
  accountEmail: 'accountEmail',
  app: 'app',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  attachment: 'attachment',
  avatar: 'avatar',
  badge: 'badge',
  banner: 'banner',
  billingContact: 'billingContact',
  billingFrequency: 'billingFrequency',
  board: 'board',
  boardOrganization: 'boardOrganization',
  boardPref: 'boardPref',
  businessClass: 'businessClass',
  button: 'button',
  cacheSyncing: 'cacheSyncing',
  card: 'card',
  cardCopy: 'cardCopy',
  cardComposer: 'cardComposer',
  checkbox: 'checkbox',
  collection: 'collection',
  comment: 'comment',
  commentsPermissions: 'commentsPermissions',
  confluenceLearningExperimentMetaData: 'confluenceLearningExperimentMetaData',
  creditCard: 'creditCard',
  description: 'description',
  download: 'download',
  drawer: 'drawer',
  drawerNavigationItem: 'drawerNavigationItem',
  dropdown: 'dropdown',
  dropdownItem: 'dropdownItem',
  dueDate: 'dueDate',
  edit: 'edit',
  editor: 'editor',
  email: 'email',
  embed: 'embed',
  eventValidation: 'eventValidation',
  error: 'error',
  feature: 'feature',
  featureFlag: 'featureFlag',
  fetchAvailableSites: 'fetchAvailableSites',
  freeTrial: 'freeTrial',
  icon: 'icon',
  inlineDialog: 'inlineDialog',
  input: 'input',
  invitation: 'invitation',
  invitationsPermissions: 'invitationsPermissions',
  inviteAcceptanceNotification: 'inviteAcceptanceNotification',
  label: 'label',
  link: 'link',
  list: 'list',
  locale: 'locale',
  location: 'location',
  member: 'member',
  mention: 'mention',
  menu: 'menu',
  menuItem: 'menuItem',
  modal: 'modal',
  mode: 'mode',
  notification: 'notification',
  observer: 'observer',
  onboarding: 'onboarding',
  option: 'option',
  organization: 'organization',
  overlay: 'overlay', // Use for info boxes, callouts within components
  panel: 'panel',
  payment: 'payment',
  pill: 'pill',
  pluginOperationalEvent: 'pluginOperationalEvent',
  pluginScreenEvent: 'pluginScreenEvent',
  pluginTrackEvent: 'pluginTrackEvent',
  pluginUIEvent: 'pluginUIEvent',
  pluginViewedComponentEvent: 'pluginViewedComponentEvent',
  performance: 'performance',
  position: 'position',
  powerUp: 'powerUp',
  prompt: 'prompt',
  primaryEmail: 'primaryEmail',
  purchase: 'purchase',
  radioButton: 'radioButton',
  reaction: 'reaction',
  reactionPicker: 'reactionPicker',
  save: 'save',
  search: 'search',
  secondaryEmail: 'secondaryEmail',
  section: 'section',
  sectionItem: 'sectionItem',
  select: 'select',
  separator: 'separator',
  serviceWorker: 'serviceWorker',
  session: 'session',
  shortcut: 'shortcut', // For keyboard shortcuts
  step: 'step',
  sticker: 'sticker',
  suggestion: 'suggestion',
  survey: 'survey',
  tab: 'tab',
  taxExemptionCertificate: 'taxExemptionCertificate',
  team: 'team',
  teamBoardDeletionRestriction: 'teamBoardDeletionRestriction',
  teamBoardInvitationRestriction: 'teamBoardInvitationRestriction',
  teamBoardVisibilityRestriction: 'teamBoardVisibilityRestriction',
  teamMembershipRestriction: 'teamMembershipRestriction',
  teamTemplatePicker: 'teamTemplatePicker',
  textField: 'textField',
  tile: 'tile',
  toggle: 'toggle',
  tooltip: 'tooltip',
  trial: 'trial',
  trelloGold: 'trelloGold',
  ui: 'ui', // this should only be used for stock "UI viewed"-type events
  upload: 'upload',
  url: 'url',
  upsell: 'upsell',
} as const;

export const ActionSubject = {
  ...boardFields,
  ...otherActionSubjects,
} as const;

export type ActionSubjectType = typeof ActionSubject[keyof typeof ActionSubject];
